import styled from 'styled-components';
import { useEffect, useRef } from 'react';

import { ViewItemV2, ViewItemV2Props } from '@/administration/pages/Course/MainLayoutView/atoms/ViewItemV2/ViewItemV2';
import { makeNamespacedComponent } from '@/ui/utils';

const RootStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: calc(100vh - 92px);
`;

const ListStyled = styled.div`
  overflow-y: scroll;
`;

type ViewDrawerV2Props = {
  items: ViewItemV2Props[];
  activeContentId: string;
};

const ViewDrawerV2Base = ({ items, activeContentId }: ViewDrawerV2Props): JSX.Element => {
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (activeContentId && listRef.current) {
      const activeElement = listRef.current.querySelector(`[data-item-id="${activeContentId}"]`) as HTMLElement;

      if (activeElement) {
        activeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [activeContentId, items]);

  return (
    <RootStyled>
      <ListStyled ref={listRef}>
        {items.map((item) => (
          <ViewItemV2 {...item} key={item.id} activeContentId={activeContentId} />
        ))}
      </ListStyled>
    </RootStyled>
  );
};

const LoadingState = (): JSX.Element => (
  <RootStyled>
    <ViewItemV2.LoadingState />
  </RootStyled>
);

export const ViewDrawerV2 = makeNamespacedComponent(ViewDrawerV2Base, {
  LoadingState,
});
